import { useEffect, useState } from "react";
import { LogOut, KeyRound, Trash2, AlertTriangle } from "lucide-react";
import { listar } from "@/lib/offlineQueue";

export default function SairDialog({ session, onSair, onCancelar }) {
  const [pendentes, setPendentes] = useState(0);
  const [apagado, setApagado] = useState(false);
  useEffect(() => {
    const meu = session?.app_user?.id;
    listar().then((l) => setPendentes(l.filter((r) => r.status !== "sincronizado" && (!r.app_user_id || r.app_user_id === meu)).length)).catch(() => {});
  }, [session]);

  if (apagado) {
    return (
      <div className="fixed inset-0 z-[10000] bg-black/80 flex items-end sm:items-center justify-center p-3" data-testid="sair-apagado">
        <div className="bg-slate-900 border border-slate-700 rounded-2xl p-5 w-full max-w-sm text-slate-100 space-y-3">
          <b>Dados de acesso apagados deste app</b>
          <p className="text-sm text-slate-300">Se você salvou a senha no gerenciador de senhas do celular, remova-a também em
            <b> Configurações → Senhas</b> (iPhone) ou <b>Gerenciador de senhas do Google</b> (Android).</p>
          <button onClick={() => onSair(true)} data-testid="btn-sair-ok" className="w-full h-12 rounded-xl bg-emerald-600 font-bold">Entendi</button>
        </div>
      </div>
    );
  }
  return (
    <div className="fixed inset-0 z-[10000] bg-black/80 flex items-end sm:items-center justify-center p-3" onClick={onCancelar}>
      <div onClick={(e) => e.stopPropagation()} className="bg-slate-900 border border-slate-700 rounded-2xl p-5 w-full max-w-sm text-slate-100 space-y-3" data-testid="sair-dialog">
        <div className="flex items-center gap-2 font-bold"><LogOut size={18} /> Sair do app</div>
        {pendentes > 0 && (
          <div className="rounded-lg border border-amber-700 bg-amber-950/50 p-3 text-xs text-amber-200 flex gap-2" data-testid="sair-aviso-pendentes">
            <AlertTriangle size={16} className="shrink-0" />
            {pendentes} batida(s) ainda não foram enviadas. Elas ficam guardadas e serão enviadas quando você entrar novamente neste celular.
          </div>
        )}
        <button onClick={() => onSair(false)} data-testid="btn-sair-manter"
          className="w-full rounded-xl bg-slate-800 hover:bg-slate-700 p-3 text-left">
          <div className="font-semibold flex items-center gap-2"><KeyRound size={15} /> Sair e manter meus dados de acesso</div>
          <div className="text-[11px] text-slate-400">Na próxima vez, o usuário (e a senha, se salva no celular) já vem preenchido.</div>
        </button>
        <button onClick={() => setApagado(true)} data-testid="btn-sair-apagar"
          className="w-full rounded-xl bg-red-950/60 border border-red-900 hover:bg-red-950 p-3 text-left">
          <div className="font-semibold flex items-center gap-2 text-red-200"><Trash2 size={15} /> Sair e apagar dados de acesso</div>
          <div className="text-[11px] text-red-300/80">Use se outra pessoa for usar este celular.</div>
        </button>
        <button onClick={onCancelar} data-testid="btn-sair-cancelar" className="w-full h-10 text-sm text-slate-400">Cancelar</button>
      </div>
    </div>
  );
}
